import { render } from "./ModalEditLimits.vue?vue&type=template&id=76f52793&scoped=true&ts=true"
import script from "./ModalEditLimits.vue?vue&type=script&lang=ts"
export * from "./ModalEditLimits.vue?vue&type=script&lang=ts"

import "./ModalEditLimits.vue?vue&type=style&index=0&id=76f52793&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f52793"]])

export default __exports__